import React from 'react';
import PropTypes from 'prop-types';
import { PlanLoaderProgressV3 } from '../PlanLoaderProgressV3';

const DELAY = 800;

function PlanLoaderSlideV3({ onContinue }) {
    const finishProgress = () => {
        setTimeout(() => {
            onContinue();
        }, DELAY);
    };

    return (
        <PlanLoaderProgressV3 finish={finishProgress} />
    );
}

PlanLoaderSlideV3.propTypes = {
    onContinue: PropTypes.func.isRequired
};

export {
    PlanLoaderSlideV3
};
